module.exports = __webpack_public_path__ + "static/media/success.6dc80986.svg";